/**
 * Badge - what is returned as part of response from the call to add practice record.
 */
export default class Badge {
  constructor({}: Badge) {
    Object.assign(this, {});
  }
}